// @import dependencies
import { CombinedReducers as IState } from 'app_events/index'
import React, {Component} from 'react'
import { connect } from 'react-redux'
// @end

// @import components
import {SchedulingModuleLayout} from 'app_components/modules/campus/academic/scheduling'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import SchedulingService from 'app_services/campus/academic/schedulingService'
import storeService from 'app_services/storeService'
// @end

// @import types
import {IMyCourse, IMyCourseTab} from 'app_types/campus/academic/myCoursesTypes'
import {ISchedulingRole} from 'app_types/campus/scheduling/schedulingModuleTypes'
// @end

// @ADD Component types
interface ISchedulingModuleProps {
  role: ISchedulingRole
}
interface ISchedulingModuleState {
  status: null | 'loading' | 'error'
  programData: {name: string, service_id: string, schedulingMode: {name: string, _id: string} } | null
  schedulingData: Array<any>
  titleComponent: string
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class SchedulingModule extends Component<ISchedulingModuleProps, ISchedulingModuleState> {

  private schedulingService: SchedulingService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ISchedulingModuleProps) {
    super(props)
    this.state = {
      status: 'loading',
      programData: null,
      schedulingData: [],
      titleComponent: 'modules.scheduling_module.title'
    }
    this.schedulingService = new SchedulingService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
   componentDidMount = async () => {
    storeService?.subscribe('courses.courseSelected',this.fetchSchedulingData)
    storeService?.subscribe('courses.courseTab',this.changeTab)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    storeService?.unsubscribe('courses.courseSelected',this.fetchSchedulingData)
    storeService?.unsubscribe('courses.courseTab',this.changeTab)
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  fetchSchedulingData = async (data: IMyCourse | null) => {

    this.setState({
      status: 'loading',
      schedulingData: [],
    })

    if (data?._id) {
      const dataResponse = await this.schedulingService.fetchSchedulingData({
        moodle_id: data?._id,
        courseSchedulingId: data?.courseScheduling,
        only_user_logged: (this.props.role === 'teacher') ? true : undefined,
        sessionStartDate: (this.props.role === 'teacher') ? undefined : {
          date: 'today',
          direction: 'gte',
        },
      }, {showError: false})

      if (dataResponse) {
        let scheduling = []
        let programData = null
        if (dataResponse.scheduling) {
          // let count = 0
          scheduling = dataResponse.scheduling.reduce((accum: Array<any>, element: any) => {
            accum.push(element)
            // count++
            return accum
          }, [])
        }
        if (dataResponse.program) {
          programData = dataResponse.program
        }
        this.setState({schedulingData: scheduling, programData, status: null})
      } else {
        this.setState(({status: null}))
      }
    } else {
      this.setState(({status: null}))
    }
  }

  changeTab = async (data: IMyCourseTab | null) => {
    if (data === IMyCourseTab.HISTORY_COURSES) {
      this.setState({titleComponent: 'modules.scheduling_module.title_history'})
    } else {
      this.setState({titleComponent: 'modules.scheduling_module.title'})
    }
  }

  render() {
    return(
      <SchedulingModuleLayout
        status={this.state.status}
        schedulingData={this.state.schedulingData}
        programData={this.state.programData}
        role={this.props.role}
        title={this.state.titleComponent}
      />
    )
  }
}

export default connect(mapStatesToProps)(SchedulingModule)
